import * as $ from "jquery";

import {$body} from 'Core/Body';
import {getCurrentLanguage} from 'Core/Languages';
import {Notifications} from 'Core/Notifications';
import {CartService, CartServiceResponse} from 'Components/Cart/CartService';
import {CartCommon} from 'Components/Cart/CartCommon';
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import "jquery.cookie";
import { AddCartModal } from "Components/Cart/AddCartModal";
import { onClick } from "Core/Events";

export const AddToCart = (() => {
    const Selector = {
        CART_ICON: {
            COUNT: ".js_cart_count",
            VALUE: "#cartValue",
            COUNT_OFFER: ".js_offer_count",
            VALUE_OFFER: "#offerValue",
        },

        PRODUCT_TILE: {
            ADD_ITEM: ".js_product_tile_add_to_cart",
        },

        CATEGORY_PAGE: {
            ADD_ITEM: '.js_category_page_add_to_cart',
            ADD_OFFER: '.js_category_page_add_to_offer',
        },

        PRODUCT_PAGE: {
            ADD_ITEM: ".js_product_page_add_to_cart",
            QUANTITY: ".js_product_page_quantity",
            ADD_OFFER: ".js_product_page_add_to_offer",
        },

        CART: {
            EMPTY_INFO: "#cart_empty",
            DELIVERY_TIME: '#DeliveryTime',
        },

        BASKET_TYPE: {
            CART_MARKER: 'js_product_cart',
            OFFER_MARKER: 'js_product_offer'
        }

    };
    const CART_COUNT_LIMIT: number = 50;
    const OFFER_COUNT_LIMIT: number = 50;

    const Message = {
        CART_COUNT_LIMIT: "W koszyku możesz mieć maksymalnie " + CART_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do koszyka przekracza limit.",
        OFFER_COUNT_LIMIT: "W kalkulacji możesz mieć maksymalnie " + OFFER_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do kalkulacji przekracza limit."
    };
    const {FORM, OFFER, SUMMARY_PANEL} = Step1Selectors;
    const lang = getCurrentLanguage;

    onClick(Selector.CATEGORY_PAGE.ADD_ITEM, ProdPageAddToCart);
    onClick(Selector.PRODUCT_PAGE.ADD_ITEM, ProdPageAddToCart);
    onClick(Selector.CATEGORY_PAGE.ADD_OFFER, ProdPageAddToCart);
    onClick(Selector.PRODUCT_PAGE.ADD_OFFER, ProdPageAddToCart);

    async function cartChangeHandler(res: CartServiceResponse, element: HTMLElement) {
        if (res.result) {
            if (res.value) {
                $(SUMMARY_PANEL.TOTAL).html(res.value.total.toString());
                let targetCounter: string;
                let targetValue: string;

                if(res.value.modKey == 'mod_bsk') {
                    targetCounter = Selector.CART_ICON.COUNT;
                    targetValue = Selector.CART_ICON.VALUE
                } else {
                    targetCounter = Selector.CART_ICON.COUNT_OFFER;
                    targetValue = Selector.CART_ICON.VALUE_OFFER
                }

                if (res.value.count > 0) {
                    $(targetCounter).show().html(res.value.count.toString());
                } else {
                    $(targetCounter).hide().html('0');
                    $(Selector.CART.EMPTY_INFO).show(250);
                    // Step1 FORM
                    $(FORM).hide(250);
                }
                $(targetValue).html(res.value.total.toString());

                const productName: string = $(element).data('product-name');
                const productId: string = $(element).data('product-id');

                if(res.value.modKey === 'mod_bsk') {
                    await AddCartModal.init({
                        productId: productId,
                        productName: productName,
                        basketType: res.value.modKey ? res.value.modKey : 'mod_bsk'
                    });
                }

            }
            Notifications.add(res.msg, res.type ? res.type : "success");
        }
    }

    function ProdPageAddToCart(event: JQuery.Event<HTMLButtonElement>) {
        event.preventDefault();

        const element = event.currentTarget;
        const { productId, productName } = element.dataset;
        let quantity: number;
        let itGoesBeyondCountLimit: boolean;
        let message: string;

        if ($(element).hasClass(Selector.BASKET_TYPE.CART_MARKER)) {
            quantity = $(Selector.PRODUCT_PAGE.QUANTITY).val() as number || 1;
            itGoesBeyondCountLimit = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT, CART_COUNT_LIMIT);
            message = Message.CART_COUNT_LIMIT;
        } else {
            quantity = $(OFFER.OFFER_QUANTITY).val() as number || 1;
            itGoesBeyondCountLimit = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT_OFFER, OFFER_COUNT_LIMIT);
            message = Message.OFFER_COUNT_LIMIT;
        }

        if (itGoesBeyondCountLimit) {
            Notifications.add(message, "warning");
        } else {
            CartService
                .add(lang, productId, quantity)
                .done((response) => {
                    cartChangeHandler(response, element);
                });
        }
    }
})();
import * as $ from "jquery";

import {$body} from 'Core/Body';
import {getCurrentLanguage} from 'Core/Languages';
import {Notifications} from 'Core/Notifications';
import {CartService, CartServiceResponse} from 'Components/Cart/CartService';
import {CartCommon} from 'Components/Cart/CartCommon';
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import "jquery.cookie";
import { AddCartModal } from "Components/Cart/AddCartModal";
import { onClick } from "Core/Events";

export const AddToCart = (() => {
    const Selector = {
        CART_ICON: {
            COUNT: ".js_cart_count",
            VALUE: "#cartValue",
            COUNT_OFFER: ".js_offer_count",
            VALUE_OFFER: "#offerValue",
        },

        PRODUCT_TILE: {
            ADD_ITEM: ".js_product_tile_add_to_cart",
        },

        CATEGORY_PAGE: {
            ADD_ITEM: '.js_category_page_add_to_cart',
            ADD_OFFER: '.js_category_page_add_to_offer',
        },

        PRODUCT_PAGE: {
            ADD_ITEM: ".js_product_page_add_to_cart",
            QUANTITY: ".js_product_page_quantity",
            ADD_OFFER: ".js_product_page_add_to_offer",
        },

        CART: {
            EMPTY_INFO: "#cart_empty",
            DELIVERY_TIME: '#DeliveryTime',
        },

        BASKET_TYPE: {
            CART_MARKER: 'js_product_cart',
            OFFER_MARKER: 'js_product_offer'
        }

    };
    const CART_COUNT_LIMIT: number = 50;
    const OFFER_COUNT_LIMIT: number = 50;

    const Message = {
        CART_COUNT_LIMIT: "W koszyku możesz mieć maksymalnie " + CART_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do koszyka przekracza limit.",
        OFFER_COUNT_LIMIT: "W kalkulacji możesz mieć maksymalnie " + OFFER_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do kalkulacji przekracza limit."
    };
    const {FORM, OFFER, SUMMARY_PANEL} = Step1Selectors;
    const lang = getCurrentLanguage;

    onClick(Selector.CATEGORY_PAGE.ADD_ITEM, ProdPageAddToCart);
    onClick(Selector.PRODUCT_PAGE.ADD_ITEM, ProdPageAddToCart);
    onClick(Selector.CATEGORY_PAGE.ADD_OFFER, ProdPageAddToCart);
    onClick(Selector.PRODUCT_PAGE.ADD_OFFER, ProdPageAddToCart);

    async function cartChangeHandler(res: CartServiceResponse, element: HTMLElement) {
        if (res.result) {
            if (res.value) {
                $(SUMMARY_PANEL.TOTAL).html(res.value.total.toString());
                let targetCounter: string;
                let targetValue: string;

                if(res.value.modKey == 'mod_bsk') {
                    targetCounter = Selector.CART_ICON.COUNT;
                    targetValue = Selector.CART_ICON.VALUE
                } else {
                    targetCounter = Selector.CART_ICON.COUNT_OFFER;
                    targetValue = Selector.CART_ICON.VALUE_OFFER
                }

                if (res.value.count > 0) {
                    $(targetCounter).show().html(res.value.count.toString());
                } else {
                    $(targetCounter).hide().html('0');
                    $(Selector.CART.EMPTY_INFO).show(250);
                    // Step1 FORM
                    $(FORM).hide(250);
                }
                $(targetValue).html(res.value.total.toString());

                const productName: string = $(element).data('product-name');
                const productId: string = $(element).data('product-id');

                if(res.value.modKey === 'mod_bsk') {
                    await AddCartModal.init({
                        productId: productId,
                        productName: productName,
                        basketType: res.value.modKey ? res.value.modKey : 'mod_bsk'
                    });
                }

            }
            Notifications.add(res.msg, res.type ? res.type : "success");
        }
    }

    function ProdPageAddToCart(event: JQuery.Event<HTMLButtonElement>) {
        event.preventDefault();

        const element = event.currentTarget;
        const { productId, productName } = element.dataset;
        let quantity: number;
        let itGoesBeyondCountLimit: boolean;
        let message: string;

        if ($(element).hasClass(Selector.BASKET_TYPE.CART_MARKER)) {
            quantity = $(Selector.PRODUCT_PAGE.QUANTITY).val() as number || 1;
            itGoesBeyondCountLimit = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT, CART_COUNT_LIMIT);
            message = Message.CART_COUNT_LIMIT;
        } else {
            quantity = $(OFFER.OFFER_QUANTITY).val() as number || 1;
            itGoesBeyondCountLimit = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT_OFFER, OFFER_COUNT_LIMIT);
            message = Message.OFFER_COUNT_LIMIT;
        }

        if (itGoesBeyondCountLimit) {
            Notifications.add(message, "warning");
        } else {
            CartService
                .add(lang, productId, quantity)
                .done((response) => {
                    cartChangeHandler(response, element);
                });
        }
    }
})();
